export default class ObaUsuarioCadastroModel {
  Nome: string = "";
  Email: string = "";
  CodigoOba?: number = 0;
  Cpf: string = "";
  Telefone: string = "";
  Bairro: string = "";
  Cidade: string = "";
  Estado: string = "";
  Sexo: string = "";
  Logradouro: string = "";
  CEP: string = "";
  Complemento: string = "";
  Numero: string = "";
  Nascimento: string = "";

  public static toModel(obj: any): ObaUsuarioCadastroModel {
    return {
      Nome: obj.nomerazao,
      Email: obj.email,
      CodigoOba: obj.seqpessoa,
      Cpf: obj.cgccpf + obj.digcgccpf,
      Telefone: obj.telefone,
      Sexo: obj.sexo,
      CEP: obj.cep,
      Complemento: obj.cmpltologradouro,
      Numero: obj.nrologradouro,
      Nascimento: obj.dtanascfund,
      Logradouro: obj.logradouro,
      Bairro: obj.bairro,
      Cidade: obj.cidade,
      Estado: obj.uf,
    } as ObaUsuarioCadastroModel;
  }

  public static toObaAPI(obj: ObaUsuarioCadastroModel): any {
    return {
      nomerazao: obj.Nome,
      sexo: obj.Sexo,
      fantasia: null,
      cgccpf: String(obj.Cpf).padStart(11, '0'),
      digcgccpf: null,
      cnpjLojaPref: null,
      foneddd1: null,
      fonenro1: obj.Telefone,
      fisicajuridica: "F",
      cidade: obj.Cidade,
      uf: obj.Estado,
      pais: "Brasil",
      bairro: obj.Bairro,
      logradouro: obj.Logradouro,
      nrologradouro: obj.Numero ? obj.Numero.toString() : "",
      cmpltologradouro: obj.Complemento,
      cep: obj.CEP,
      inscricaorg: null,
      inscmunicipal: null,
      telefone: obj.Telefone,
      email: obj.Email,
      dtanascfund: obj.Nascimento,
    };
  }
}
